module.exports = __webpack_public_path__ + "static/index/img/baikal-112.f438be1b.jpg";